import { useCallback, useState } from 'react';
import { Button, Form, Input } from 'antd';
import Icon, { Icons } from 'icons';

import { classnames } from 'lib/classnames';
import fetch, { getGateway } from 'lib/fetch';
import useAsync from 'lib/hooks/useAsync';
import useI18n from 'lib/hooks/useI18n';

import styles from './ForgetPassword.module.less';

const cx = classnames(styles);
interface ForgetPasswordProps {
  go: (key: string) => void;
}

enum ForgetPasswordPageType {
  FORGET_PASSWORD = 'forget-password', // 忘记密码页面
  SUCCESS = 'success', // 发送邮件成功
}

const ForgetPassword: React.VFC<ForgetPasswordProps> = ({ go }) => {
  const { t } = useI18n();
  const { loading, hack } = useAsync();
  const [pageType, setPageType] = useState(ForgetPasswordPageType.FORGET_PASSWORD);
  const [mailError, setMailError] = useState({});

  const sendMail = useCallback(
    async email => {
      const [error] = await hack(
        () =>
          fetch.$post(`/api/auth/user/reset/sendMail`, { email }, { baseURL: getGateway(), hiddenErrorModal: true }),
        { isShowError: false },
      )();
      if (error) {
        setMailError({ validateStatus: 'error', help: error?.data?.error || t('libs.error.default.errorData') });
        return;
      }
      setPageType(ForgetPasswordPageType.SUCCESS);
    },
    [hack],
  );

  return (
    <div className={cx('forget-password-wrap')}>
      <Icon className={cx('login-back-icon')} component={Icons.BackArrow} onClick={() => go('login')} />
      <p className={cx('login-header-title')}>{t('views.login.btn.forget')}</p>
      {pageType === ForgetPasswordPageType.FORGET_PASSWORD && (
        <>
          <p className={cx('login-header-text')}>{t('views.login.email.resetTip')}</p>
          <Form initialValues={{}} onFinish={data => sendMail(data.email)} onFieldsChange={() => setMailError({})}>
            <Form.Item
              name="email"
              rules={[{ required: true, message: t('pages.users.validate.mailEnsure') }]}
              {...(mailError || {})}
            >
              <Input placeholder={t('pages.users.validate.mailEnsure')} />
            </Form.Item>
            <Button className={cx('login-button')} htmlType="submit" type="primary" loading={loading}>
              {t('views.login.email.send')}
            </Button>
          </Form>
        </>
      )}
      {pageType === ForgetPasswordPageType.SUCCESS && (
        <div className={cx('login-success-wrap')}>
          <Icon className={cx('login-success-icon')} component={Icons.Alert_Success} />
          <p className={cx('login-header-text')}>{t('views.login.email.ensure')}</p>
          <p className={cx('login-header-text')}>{t('views.login.email.help')}</p>
          <Button className={cx('login-button')} type="primary" onClick={() => go('login')}>
            {t('views.login.btn.backLogin')}
          </Button>
        </div>
      )}
    </div>
  );
};

export default ForgetPassword;
